module.exports = __webpack_public_path__ + "img/instagram2.304fb315.svg";